import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Prettify } from 'common/helper/typeHelper';
import { TerminalExamTypeModel } from 'data/exam/exam.model';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: Prettify<TerminalExamTypeModel>[];
  error: any;
};

const initState: SliceState = {
  status: 'idle',
  data: [],
  error: false,
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<Prettify<TerminalExamTypeModel>[]>> = (
  _,
  action,
) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: [],
  status: 'error',
});

const examTerminalTypeSlice = createSlice({
  name: 'examTerminalType',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default examTerminalTypeSlice;
